import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'

// Firebase instances (initialized in firebase.sagas.js)
let firebaseApp = null
let auth = null
let database = null

// Initialize Firebase (called from firebase.sagas.js)
export const initializeFirebase = (config) => {
  firebaseApp = initializeApp(config)
  auth = getAuth(firebaseApp)
  database = getDatabase(firebaseApp)
  return { firebaseApp, auth, database }
}

// Get Firebase instances
export const getFirebaseApp = () => firebaseApp
export const getFirebaseAuth = () => auth
export const getFirebaseDatabase = () => database

// Check if Firebase is initialized
export const isFirebaseInitialized = () => !!firebaseApp